var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.statusLabelComputed,"loading":_vm.loading,"disabled":_vm.disabled,"dense":""},on:{"change":_vm.change},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }